export var ParamType = /* @__PURE__ */ ((ParamType2) => {
  ParamType2["BOOLEAN"] = "boolean";
  ParamType2["BUTTON"] = "button";
  ParamType2["COLOR"] = "color";
  ParamType2["FLOAT"] = "float";
  ParamType2["FOLDER"] = "folder";
  ParamType2["INTEGER"] = "integer";
  ParamType2["PARAM_PATH"] = "param_path";
  ParamType2["NODE_PATH"] = "node_path";
  ParamType2["RAMP"] = "ramp";
  ParamType2["STRING"] = "string";
  ParamType2["VECTOR2"] = "vector2";
  ParamType2["VECTOR3"] = "vector3";
  ParamType2["VECTOR4"] = "vector4";
  return ParamType2;
})(ParamType || {});
